import SectionHeader from "./SectionHeader";

const TIPS = [
  { no: "01", icon: "ri-eye-off-line", title: "先确认，再转发", desc: "内容未经证实前别急着下结论，也不要拿着片段去当事人面前追问。吃瓜的前提是不制造二次伤害。" },
  { no: "02", icon: "ri-chat-3-line", title: "少一些评判，多一些旁观", desc: "情感里的对错往往说不清。隔着屏幕看故事，多一些理解，少用『渣男渣女』的标签去定义任何人。" },
  { no: "03", icon: "ri-shield-user-line", title: "守住隐私红线", desc: "不人肉搜索、不传播涉及真实身份的信息。娱乐归娱乐，不能越界到现实生活里的每个人。" },
  { no: "04", icon: "ri-mental-health-line", title: "先过好自己的生活", desc: "看再多故事，也别忘了自己才是主角。累了就放下手机，去上课、去运动、去见真正喜欢的人。" },
];

export default function TipsBand() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="理性吃瓜指南"
          title="吃瓜有度 · 温柔围观"
          desc="看热闹是天性，但守住边界才是本事。送你四条吃瓜守则，让娱乐永远是娱乐。"
        />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {TIPS.map((t, idx) => (
            <article
              key={t.no}
              className={`flex flex-col rounded-xl border p-5 md:p-6 ${
                idx === 0 ? "border-accent-300/70 bg-accent-100/60" : "border-background-300/60 bg-background-50"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl text-lg ${
                    idx === 0 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  <i className={t.icon} aria-hidden="true" />
                </span>
                <span className="font-heading text-2xl font-black text-background-300">{t.no}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{t.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{t.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}